export default __webpack_public_path__ + "static/media/vltc.4354be3e.png";